/**
 * @generated SignedSource<<26604b31561a9a917a1d8b0811bdaef6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeStoryPackageLeadContentItemContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "homeStoryPackageLeadContentItemContent";
};
export type homeStoryPackageLeadContentItemContent$key = {
  readonly " $data"?: homeStoryPackageLeadContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeStoryPackageLeadContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeStoryPackageLeadContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "e727219e1b279b3cf6e2e27e188a2934";

export default node;
